import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, Fragment as _Fragment, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-743b46f2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "container-fluid justify-content-center"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-center mt-4 text-break small p-3" }, null, -1))
const _hoisted_3 = { class: "d-flex justify-content-center mt-1 mx-1" }
const _hoisted_4 = {
  class: "card rounded-0",
  style: {"width":"30rem"}
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header fw-bold rounded-0" }, " Now building your AvatarDex! ", -1))
const _hoisted_6 = { class: "list-group list-group-flush" }
const _hoisted_7 = { class: "list-group-item rounded-0" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Fetching public address ")
const _hoisted_9 = { class: "ms-1" }
const _hoisted_10 = {
  key: 0,
  class: "bi bi-check-circle-fill"
}
const _hoisted_11 = {
  key: 1,
  class: "bi bi-x-circle-fill"
}
const _hoisted_12 = /*#__PURE__*/_createTextVNode("...")
const _hoisted_13 = {
  key: 0,
  class: "list-group-item rounded-0"
}
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Loading Avatar tokens ")
const _hoisted_15 = { class: "ms-1" }
const _hoisted_16 = {
  key: 0,
  class: "bi bi-check-circle-fill"
}
const _hoisted_17 = {
  key: 1,
  class: "bi bi-x-circle-fill"
}
const _hoisted_18 = /*#__PURE__*/_createTextVNode("...")
const _hoisted_19 = {
  key: 0,
  class: "d-flex justify-content-center mt-4 mx-1 small"
}
const _hoisted_20 = {
  class: "alert alert-danger rounded-0",
  role: "alert",
  style: {"width":"30rem"}
}
const _hoisted_21 = { class: "fw-bold" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" Please check that the input is correct. ")
const _hoisted_25 = {
  key: 1,
  class: "d-flex justify-content-center mt-4 mx-1 small"
}
const _hoisted_26 = {
  class: "alert alert-danger rounded-0",
  role: "alert",
  style: {"width":"30rem"}
}
const _hoisted_27 = { class: "fw-bold" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" There may be an issue with the server or API. ")
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_33 = /*#__PURE__*/_createTextVNode(" Please try again momentarily. If the error persists, please contact me on Reddit: u/vanderdev or Twitter: @vander_dev ")
const _hoisted_34 = {
  key: 2,
  class: "d-flex justify-content-center mx-1 small"
}
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "/" }, "Go back", -1))
const _hoisted_36 = [
  _hoisted_35
]

import { onMounted } from "vue";
import { useStore } from "vuex";
import { State } from "@/store";

interface Props {
    accountInput: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AccountLoader',
  props: {
    accountInput: null
  },
  setup(__props: any) {

const props = __props as {
    accountInput: string;
}

const store = useStore();
const state = store.state as State;



onMounted(async () => {
    store.commit("SETUP_AVATARDEX", { accountInput: props.accountInput });
    await store.dispatch("init");
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_unref(state).dataLoaded)
      ? (_openBlock(), _createBlock(_component_router_view, { key: 0 }))
      : (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("ul", _hoisted_6, [
                _createElementVNode("li", _hoisted_7, [
                  _hoisted_8,
                  _createElementVNode("span", _hoisted_9, [
                    (_unref(state).baseAddress)
                      ? (_openBlock(), _createElementBlock("i", _hoisted_10))
                      : (
                                        _unref(state).getAddressError || _unref(state).dataError
                                    )
                        ? (_openBlock(), _createElementBlock("i", _hoisted_11))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                            _hoisted_12
                          ], 64))
                  ])
                ]),
                (_unref(state).baseAddress)
                  ? (_openBlock(), _createElementBlock("li", _hoisted_13, [
                      _hoisted_14,
                      _createElementVNode("span", _hoisted_15, [
                        (_unref(state).dataLoaded)
                          ? (_openBlock(), _createElementBlock("i", _hoisted_16))
                          : (_unref(state).dataError)
                            ? (_openBlock(), _createElementBlock("i", _hoisted_17))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                _hoisted_18
                              ], 64))
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          (_unref(state).getAddressError)
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("span", _hoisted_21, "There was an error finding the account for " + _toDisplayString(_unref(state).accountInput), 1),
                  _hoisted_22,
                  _hoisted_23,
                  _hoisted_24
                ])
              ]))
            : _createCommentVNode("", true),
          (_unref(state).dataError)
            ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("span", _hoisted_27, "There was an error loading the account data for " + _toDisplayString(_unref(state).accountInput), 1),
                  _hoisted_28,
                  _hoisted_29,
                  _hoisted_30,
                  _hoisted_31,
                  _hoisted_32,
                  _hoisted_33
                ])
              ]))
            : _createCommentVNode("", true),
          (_unref(state).getAddressError || _unref(state).dataError)
            ? (_openBlock(), _createElementBlock("div", _hoisted_34, _hoisted_36))
            : _createCommentVNode("", true)
        ]))
  ]))
}
}

})